export default {
  title: 'Pre-comandă',
  categories: {
    title: 'Cele mai populare',
  },
  header: {
    pickup: 'Ridicare în 5 Minute',
  },
};
